import * as types from './meeting-dashboard.types';
import * as constants from './meeting-dashboard.constants';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';
import {
  ICreateMeetingFolder,
  ICreateMeetingShortcut,
  IMeetingFolder,
  IMeetingShortcut,
  IMeetingSubFolder,
} from '../../resource/meeting-shortcuts/meeting-shortcuts.types';
import { IMeeting } from '../../resource/meeting/meeting.types';

export const initialMeetingDashboardPage = (
  currentMeetingId: IMeetingSimple['id'],
): types.IInitialMeetingDashboardPage => ({
  type: constants.INITIAL_MEETING_DASHBOARD_PAGE,
  payload: currentMeetingId,
});

export const meetingShortcutsCreateFolderlMeetingDashboardPage = (
  meetingId: IMeeting['id'],
  name: ICreateMeetingFolder['name'],
  parentId?: ICreateMeetingFolder['parentId'],
): types.IMeetingShortcutsCreateFolderDashboardPage => ({
  type: constants.MEETING_SHORTCUT_CREATE_FOLDER_MEETING_DASHBOARD_PAGE,
  payload: {
    meetingId,
    name,
    parentId,
  },
});

export const teamFilesSelectedFolderlMeetingDashboardPage = (
  meetingId: IMeeting['id'],
  folder: IMeetingFolder | IMeetingSubFolder,
): types.IMeetingShortcutsSelectedFolderDashboardPage => ({
  type: constants.MEETING_SHORTCUT_SELECTED_FOLDER_MEETING_DASHBOARD_PAGE,
  payload: { folder, meetingId },
});

export const teamFilesOnDeselectFolderlMeetingDashboardPage = (
  meetingId: IMeeting['id'],
): types.IMeetingShortcutsOnDeselectFolderDashboardPage => ({
  type: constants.MEETING_SHORTCUT_UNSELECTED_FOLDER_MEETING_DASHBOARD_PAGE,
  payload: { meetingId },
});

export const teamFilesDeleteFilelMeetingDashboardPage = (
  meetingId: IMeeting['id'],
  fileFolderId: IMeetingShortcut['id'],
): types.IMeetingShortcutDeleteFileDashboardPage => ({
  type: constants.MEETING_SHORTCUT_DELETE_FILE_MEETING_DASHBOARD_PAGE,
  payload: { meetingId, fileFolderId },
});

export const teamFilesCreateFilelMeetingDashboardPage = (
  meetingId: IMeeting['id'],
  externalLink: ICreateMeetingShortcut['externalLink'],
  description: ICreateMeetingShortcut['description'],
  folderId: ICreateMeetingShortcut['folderId'],
  name: ICreateMeetingShortcut['name'],
): types.IMeetingShortcutsCreateFileDashboardPage => ({
  type: constants.MEETING_SHORTCUT_CREATE_FILE_MEETING_DASHBOARD_PAGE,
  payload: {
    meetingId,
    externalLink,
    description,
    folderId,
    name,
  },
});

export const meetingShortcutUpdate = (
  shortcutId: IMeetingShortcut['id'],
  shortcut: ICreateMeetingShortcut,
): types.IMeetingShortcutUpdate => ({
  type: constants.MEETING_SHORTCUT_UPDATE_PAGE,
  payload: {
    id: shortcutId,
    data: shortcut,
  },
});

export const meetingShortcutDelete = (
  shortcutId: IMeetingShortcut['id'],
  meetingId: IMeetingSimple['id'],
): types.IMeetingShortcutDelete => ({
  type: constants.MEETING_SHORTCUT_DELETE_PAGE,
  payload: {
    shortcutId,
    meetingId,
  },
});
